/**
 * Active Subscription Checker — MangoTV
 * Ported from GloTV: src/utils/activeSubs.js
 *
 * Validates whether any subscription in the user's purchase history
 * is currently active by checking status + date ranges.
 *
 * @param {Array} userSubscriptions — Array of subscription/order objects from CRM /orders/
 * @returns {boolean} — true if at least one subscription is currently active
 */
export const checkActiveSubscription = (userSubscriptions) => {
  if (!userSubscriptions || !Array.isArray(userSubscriptions) || userSubscriptions.length === 0) {
    return false;
  }

  const currentDateTime = new Date();

  for (const subscription of userSubscriptions) {
    // Check if the subscription has "Active" status
    if (subscription.status === "Active" || subscription.status === "active") {
      // If we have date range info, verify current time falls within it
      if (subscription.purchase_date && subscription.end_date) {
        const startDate = new Date(
          subscription.purchase_date + (subscription.purchase_time ? " " + subscription.purchase_time : "")
        );
        const endDate = new Date(
          subscription.end_date + (subscription.end_time ? " " + subscription.end_time : "")
        );

        if (currentDateTime >= startDate && currentDateTime <= endDate) {
          return true; // Active and within date range
        }
      } else {
        // Status is Active but no date fields — trust the status
        return true;
      }
    }
  }

  return false;
};
